module.exports = __webpack_public_path__ + "static/media/fiveg-coverage-thumbnail.ae0bf9a6.png";